<template>

    <div class="contact-us-form">

        <div class="box-items box-items-hover box-items-aside">

            <a href="#"class="item" v-for="option in options" :key="option.id" @click="selectEmailTo(option)">
                <h2 class="title title-sm" v-text="option.title"></h2>
                <span v-text="option.phone"></span>
                <i :class="option.icon"></i>
            </a>

        </div>

        <div class="form">
            <form action="#" method="post">
                <field-select v-model="form.email_to" name="email_to" placeholder="I'm contacting NLCAA for">
                    <option v-for="(user) in options" :value="user.email" v-text="user.title"></option>
                </field-select>
                <field-input v-model="form.first_name" name="first_name" placeholder="First Name"></field-input>
                <field-input v-model="form.last_name" name="last_name" placeholder="Last Name"></field-input>
                <field-input type="email" v-model="form.email" name="email" placeholder="Email Address"></field-input>
                <field-phone v-model="form.phone" name="phone" placeholder="Phone Number"></field-phone>
                <field-text v-model="form.message" name="message" placeholder="Your Message"></field-text>
                <submit-button :form="form" class="btn btn-primary" icon="fa-paper-plane" @click="submit()">Send</submit-button>
            </form>

        </div>
    </div>

</template>
<script>
    export default {

        props: {
            options: {
                type: Array,
                required: true,
            }
        },

        data(){
            return {
                form: new Form({
                    email_to: '',
                    first_name: '',
                    last_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    message: '',
                })
            }
        },

        methods:{

            selectEmailTo(option) {
                this.form.email_to = option.email
            },

            submit(){
                this.form.post('/contact-us').then(response => {
                    Alert.success(response.message)
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            }
        }

    }
</script>